module.exports = __webpack_public_path__ + "media/components/country-flag/static/ug-423ce54b0ecb9580ff0100c19661892a.svg";